/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface AuthVisitorAuthenticationCodeRequestResponseVisitorVisitorContactRequestData
 */
export interface AuthVisitorAuthenticationCodeRequestResponseVisitorVisitorContactRequestData {
  /**
   *
   * @type {string}
   * @memberof AuthVisitorAuthenticationCodeRequestResponseVisitorVisitorContactRequestData
   */
  status?: string
}

export function AuthVisitorAuthenticationCodeRequestResponseVisitorVisitorContactRequestDataFromJSON(
  json: any
): AuthVisitorAuthenticationCodeRequestResponseVisitorVisitorContactRequestData {
  return AuthVisitorAuthenticationCodeRequestResponseVisitorVisitorContactRequestDataFromJSONTyped(json, false)
}

export function AuthVisitorAuthenticationCodeRequestResponseVisitorVisitorContactRequestDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AuthVisitorAuthenticationCodeRequestResponseVisitorVisitorContactRequestData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status']
  }
}

export function AuthVisitorAuthenticationCodeRequestResponseVisitorVisitorContactRequestDataToJSON(
  value?: AuthVisitorAuthenticationCodeRequestResponseVisitorVisitorContactRequestData | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status
  }
}
